// src/components/Landing/LogoCarousel.js
import React from 'react';
import './LogoCarousel.css';

const logos = [
  '/logo-empresas/logo1.png',
  '/logo-empresas/logo2.png',
  '/logo-empresas/logo3.png',
  '/logo-empresas/logo4.png',
  '/logo-empresas/logo9.png',
  '/logo-empresas/logo5.png',
];

const LogoCarousel = () => {
  // Duplicamos a lista de logos para garantir um efeito de loop contínuo e suave.
  const line1Logos = [...logos, ...logos]; 

  return (
    <section className="lp-logo-carousel-section">
      <div className="lp-carousel-container">
        <div className="lp-carousel-track-left">
          {line1Logos.map((logo, index) => (
            <img 
              key={`line1-${index}`} 
              src={logo} 
              alt={`Empresa ${index + 1}`} 
              className="lp-carousel-logo" 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoCarousel;